import script from "./PaymentReceipts.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReceipts.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReceipts.vue?vue&type=style&index=0&id=54703e99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54703e99"]])

export default __exports__